import * as React from 'react'

import './src/styles/global.css'

export const wrapRootElement = ({ element }) => {
  return <React.StrictMode>{element}</React.StrictMode>
}
